import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import * as styles from "../styles/Header.module.scss";
import { theme } from "../styles/theme";
import { useNavigate } from "react-router-dom";

const Header = (props: { title: string }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <AppBar
      className={styles.Header}
      position="sticky"
      sx={{
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        boxShadow: 1
      }}
    >
      <Box className={styles.container}>
        <IconButton
          sx={{
            color: theme.palette.common.black
          }}
          aria-label="Back"
          onClick={handleGoBack}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h3">{props.title}</Typography>
      </Box>
    </AppBar>
  );
};

export default Header;